import countries from '../data/countries.json';

const useCountries = () => {
  return { countries: countries as string[], loading: false };
};

export default useCountries;
